import { render, staticRenderFns } from "./procurementOverview.vue?vue&type=template&id=9028f762&scoped=true"
import script from "./procurementOverview.vue?vue&type=script&lang=js"
export * from "./procurementOverview.vue?vue&type=script&lang=js"
import style0 from "./procurementOverview.vue?vue&type=style&index=0&id=9028f762&prod&lang=scss&scoped=true"
import style1 from "./procurementOverview.vue?vue&type=style&index=1&id=9028f762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028f762",
  null
  
)

export default component.exports